import { NgModule } from '@angular/core'
import { CollectionsRoutingModule } from './collections-routing.module'
import { EntityHubModule } from '../entity-hub/entity-hub.module'
@NgModule({
  imports: [CollectionsRoutingModule, EntityHubModule]
})
export class CollectionsModule {}
